import { mensShoppingCategoryMenu } from "./mens-shopping-category-menu-outdoor";
import { womensShoppingCategoryMenu } from "./womens-shopping-category-menu-outdoor";
import { footwearShoppingCategoryMenu } from "./footwear-shopping-category-menu-outdoor";
import { EMAIL_SIGNUP } from "../constants/links";
import {
  isBlackFridaySaleEnabled,
  getUnder50Label,
  getUnder100Label,
  getUnder200Label,
  isGiftGuideEnabled,
} from "../helpers/outdoor";
import { generateNavLink } from "../../utils/generateNavLink";

const EMEA_BLOCK_ARR = [
  "AT-block",
  "BE-block",
  "CZ-block",
  "DK-block",
  "FI-block",
  "FR-block",
  "DE-block",
  "GB-block",
  "IE-block",
  "IT-block",
  "NO-block",
  "PL-block",
  "ES-block",
  "SE-block",
  "CH-block",
  "NL-block",
];

const displayProductAdvice = (data, language) => {
  if (language !== "en") {
    return "";
  }
  return `
    <li class="product-advice">
            <a data-linkid="explore:product-advice" href="/product-advice">${data["Product Advice"]}</a>
            </li>
      `;
};

const womensGiftGuideMenu = (data, country) => `
    <ul class="explore">
        <li class="sectionhead gifts" tabindex="1">
            <a href="/c/womens/p/gifts-for-her" data-linkid="women:gifts" data-prefix="women">${data["For Her"]}</a>
        </li>
        <div class="mobilefly">
            <li class="gifts">
                <a  data-linkid="women:gifts" data-prefix="women" href="/c/womens/gg-gifts-for-her/wid-1jwr48gl">${
                  data["Gifts for Her"]
                }</a>
            </li>
            <li class="best-sellers">
                <a  data-linkid="women:best-sellers" data-prefix="women" href="/c/womens/p/best-sellers">${
                  data["Best Sellers"]
                }</a>
            </li>
            <li class="gifts-under-50">
                <a  data-linkid="women:gifts-under-50" data-prefix="women" href="/c/womens/p/gifts-under-50">${getUnder50Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="gifts-under-100">
                <a  data-linkid="women:gifts-under-100" data-prefix="women" href="/c/womens/p/gifts-under-100">${getUnder100Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="gifts-under-200">
                <a  data-linkid="women:gifts-under-200" data-prefix="women" href="/c/womens/p/gifts-under-200">${getUnder200Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="run-gifts">
                <a  data-linkid="women:run-gifts" data-prefix="women" href="/c/womens/p/athlete-picks-run">${
                  data["Run Gifts for Her"]
                }</a>
            </li>
            <li class="climb-gifts">
                <a  data-linkid="women:climb-gifts" data-prefix="women" href="/c/womens/p/athlete-picks-climb">${
                  data["Climb Gifts for Her"]
                }</a>
            </li>
            <li class="ski-snow">
                <a  data-linkid="women:ski-snow" data-prefix="women" href="/c/womens/p/athlete-picks-ski">${
                  data["Ski + Snow for Her"]
                }</a>
            </li>
            <li class="hike-gifts">
                <a  data-linkid="women:hike-gifts" data-prefix="women" href="/c/womens/p/athlete-picks-hike">${
                  data["Hike Gifts for Her"]
                }</a>
            </li>
            <li class="veilance-gifts">
                <a  data-linkid="women:veilance-gifts" data-prefix="women" href="/c/womens/p/veilance-gifts">${
                  data["Veilance Gifts for Her"]
                }</a>
            </li>
        </div>
    </ul>
`;

const mensGiftGuideMenu = (data, country) => `
    <ul class="explore">
        <li class="sectionhead gifts" tabindex="1">
            <a href="/c/mens/p/gifts-for-him" data-linkid="men:gifts" data-prefix="men">${data["For Him"]}</a>
        </li>
        <div class="mobilefly">
            <li class="gifts">
                <a  data-linkid="men:gifts" data-prefix="men" href="/c/mens/gg-gifts-for-him/wid-1jwr48gl">${
                  data["Gifts for Him"]
                }</a>
            </li>
            <li class="best-sellers">
                <a  data-linkid="men:best-sellers" data-prefix="men" href="/c/mens/p/best-sellers">${
                  data["Best Sellers"]
                }</a>
            </li>
            <li class="gifts-under-50">
                <a  data-linkid="men:gifts-under-50" data-prefix="men" href="/c/mens/p/gifts-under-50">${getUnder50Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="gifts-under-100">
                <a  data-linkid="men:gifts-under-100" data-prefix="men" href="/c/mens/p/gifts-under-100">${getUnder100Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="gifts-under-200">
                <a  data-linkid="men:gifts-under-200" data-prefix="men" href="/c/mens/p/gifts-under-200">${getUnder200Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="run-gifts">
                <a  data-linkid="men:run-gifts" data-prefix="men" href="/c/mens/p/athlete-picks-run">${
                  data["Run Gifts for Him"]
                }</a>
            </li>
            <li class="climb-gifts">
                <a  data-linkid="men:climb-gifts" data-prefix="men" href="/c/mens/p/athlete-picks-climb">${
                  data["Climb Gifts for Her"]
                }</a>
            </li>
            <li class="ski-snow">
                <a  data-linkid="women:ski-snow" data-prefix="men" href="/c/mens/p/athlete-picks-ski">${
                  data["Ski + Snow for Him"]
                }</a>
            </li>
            <li class="hike-gifts">
                <a  data-linkid="women:hike-gifts" data-prefix="men" href="/c/mens/p/athlete-picks-hike">${
                  data["Hike Gifts for Him"]
                }</a>
            </li>
            <li class="veilance-gifts">
                <a  data-linkid="women:veilance-gifts" data-prefix="men" href="/c/mens/p/veilance-gifts">${
                  data["Veilance Gifts for Him"]
                }</a>
            </li>
        </div>
    </ul>
`;

const mensListItem = (data, country) => `
        <li>
            <span id="men" class="head">
                <a href="/c/mens" id="main-nav-men" data-linkid="main-nav:men" data-prefix="men">${data.Mens}</a>
            </span>
            <div class="sub-menu">
                <div class="container">
                    ${mensShoppingCategoryMenu(data, country)}
                    <div class="feature">
                        <a class="content" data-linkid="mens:exclusives" href="/c/mens/exclusives">
                            <h6 data-prefix="men">${data.Exclusives}</h6>
                        </a>
                    </div>
                </div>
            </div>
        </li>
`;

const womensListItem = (data, country) => `
        <li>
            <span id="women" class="head">
                <a href="/c/womens" id="main-nav-women" data-linkid="main-nav:women" data-prefix="women">${
                  data.Womens
                }</a>
            </span>
            <div class="sub-menu">
                <div class="container">
                    ${womensShoppingCategoryMenu(data, country)}
                    <div class="feature">
                        <a class="content" data-linkid="womens:exclusives" href="/c/womens/exclusives">
                            <h6 data-prefix="women">${data.Exclusives}</h6>
                        </a>
                    </div>
                </div>
            </div>
        </li>
`;

const giftGuide = data => `
    <li class="US-block CA-block ${EMEA_BLOCK_ARR.join(" ")}">
        <span id="gift-guide" class="head gift-guide">
            <a id="gift-guide" data-linkid="main-nav:gift-guide">${data["$^nav-gift-guide^$"]}</a>
        </span>
        <div class="sub-menu">
            <div class="container">
                <ul class="footwear">
                    <ul class="gift-guide-feature-image">
                        ${generateNavLink({
                          text: data["Gifts for Her"],
                          dataLinkId: ["gift-guide", "women", "gift-for-her"],
                          href: "/c/womens/gg-gifts-for-her/wid-1jwr48gl",
                          className: "gift-guide-gifts-for-her sectionhead ",
                        })}
                        <div class="mobilefly">
                            ${generateNavLink({
                              text: data["Best Sellers"],
                              dataLinkId: ["gift-guide", "women", "best-sellers"],
                              href: "/c/womens/gg-best-sellers/wid-1jwr48gl",
                              className: "gift-guide-best-sellers",
                            })}
                            ${generateNavLink({
                              text: data["Stocking Stuffers"],
                              dataLinkId: ["gift-guide", "women", "stocking-stuffers"],
                              href: "/c/womens/gg-stocking-stuffers/wid-1jwr48gl",
                              className: "gift-guide-stocking-stuffers",
                            })}
                            ${generateNavLink({
                              text: data["Small Gifts"],
                              dataLinkId: ["gift-guide", "women", "small-gifts"],
                              href: "/c/womens/gg-small-gifts/wid-1jwr48gl",
                              className: "gift-guide-small-gifts",
                            })}
                            ${generateNavLink({
                              text: data["Warm Layers"],
                              dataLinkId: ["gift-guide", "women", "warm-layers"],
                              href: "/c/womens/gg-gifts-for-warmth/wid-1jwr48gl",
                              className: "gift-guide-warm-layers",
                            })}
                            ${generateNavLink({
                              text: data["Athlete Picks"],
                              dataLinkId: ["gift-guide", "women", "athlete-picks"],
                              href: "/c/womens/gg-athlete-picks/wid-1jwr48gl",
                              className: "guift-guide-athlete-picks",
                            })}
                        </div>
                    </ul>
                    <ul class="shop-more">
                        ${generateNavLink({
                          text: data["Gifts for Him"],
                          dataLinkId: ["gift-guide", "men", "gift-for-him"],
                          href: "/c/mens/gg-gifts-for-him/wid-1jwr48gl",
                          className: "gift-guide-gifts-for-him sectionhead",
                        })}
                        <div class="mobilefly">
                            ${generateNavLink({
                              text: data["Best Sellers"],
                              dataLinkId: ["gift-guide", "men", "best-sellers"],
                              href: "/c/mens/gg-best-sellers/wid-1jwr48gl",
                              className: "gift-guide-best-sellers",
                            })}
                            ${generateNavLink({
                              text: data["Stocking Stuffers"],
                              dataLinkId: ["gift-guide", "men", "stocking-stuffers"],
                              href: "/c/mens/gg-stocking-stuffers/wid-1jwr48gl",
                              className: "gift-guide-stocking-stuffers",
                            })}
                            ${generateNavLink({
                              text: data["Small Gifts"],
                              dataLinkId: ["gift-guide", "men", "small-gifts"],
                              href: "/c/mens/gg-small-gifts/wid-1jwr48gl",
                              className: "gift-guide-small-gifts",
                            })}
                            ${generateNavLink({
                              text: data["Warm Layers"],
                              dataLinkId: ["gift-guide", "men", "warm-layers"],
                              href: "/c/mens/gg-gifts-for-warmth/wid-1jwr48gl",
                              className: "gift-guide-warm-layers",
                            })}
                            ${generateNavLink({
                              text: data["Athlete Picks"],
                              dataLinkId: ["gift-guide", "men", "athlete-picks"],
                              href: "/c/mens/gg-athlete-picks/wid-1jwr48gl",
                              className: "guift-guide-athlete-picks",
                            })}
                        </div>
                    </ul>
                </ul>
                <div class="feature">
                    <a class="content" data-linkid="gift-guide:bestsellers" href="/c/womens/gg-best-sellers/wid-1jwr48gl">
                        <h6>${data["Best Sellers"]}</h6>
                    </a>
                </div>
            </div>
        </div>
    </li>
`;

const salesTab = data => `
    <li class="US-block ${EMEA_BLOCK_ARR.join(" ")} CA-block">
        <span id="sale" class="head sale">
            <a id="sale" data-linkid="main-nav:sale">${data.Sale}</a>
        </span>
        <div class="sub-menu">
            <div class="container">
                <ul class="footwear">
                    <ul class="sales-feature-image">
                        ${generateNavLink({
                          text: data.Womens,
                          dataLinkId: ["sale", "women", "women"],
                          href: "/c/womens/black-friday-sale/wid-kjyr6zq9",
                          className: "sectionhead sale-women-links",
                        })}
                        <div class="mobilefly">
                            ${generateNavLink({
                              text: data["Shell Jackets"],
                              dataLinkId: ["sale", "women", "shell-jackets"],
                              href: "/c/womens/bfs-shell-jackets/wid-kjyr6zq9",
                              className: "sale-women-links",
                            })}
                            ${generateNavLink({
                              text: data["Insulated Jackets"],
                              dataLinkId: ["sale", "women", "insulated-jackets"],
                              href: "/c/womens/bfs-insulated-jackets/wid-kjyr6zq9",
                              className: "sale-women-links",
                            })}
                            ${generateNavLink({
                              text: data.Bottoms,
                              dataLinkId: ["sale", "women", "bottoms"],
                              href: "/c/womens/bfs-bottoms/wid-kjyr6zq9",
                              className: "sale-women-links",
                            })}
                            ${generateNavLink({
                              text: data.Accessories,
                              dataLinkId: ["sale", "women", "accessories"],
                              href: "/c/womens/bfs-accessories/wid-kjyr6zq9",
                              className: "sale-women-links",
                            })}
                            ${generateNavLink({
                              text: data.Packs,
                              dataLinkId: ["sale", "women", "packs"],
                              href: "/c/womens/bfs-packs/wid-kjyr6zq9",
                              className: "sale-women-links",
                            })}
                            ${generateNavLink({
                              text: data["Base Layer"],
                              dataLinkId: ["sale", "women", "base-layer"],
                              href: "/c/womens/bfs-base-layers/wid-kjyr6zq9",
                              className: "sale-women-links",
                            })}
                            ${generateNavLink({
                              text: data.Footwear,
                              dataLinkId: ["sale", "women", "footwear"],
                              href: "/c/womens/bfs-footwear/wid-kjyr6zq9",
                              className: "sale-women-links",
                            })}
                            ${generateNavLink({
                              text: data.Fleece,
                              dataLinkId: ["sale", "women", "fleece"],
                              href: "/c/womens/bfs-fleece/wid-kjyr6zq9",
                              className: "sale-women-links",
                            })}
                            ${generateNavLink({
                              text: "Veilance",
                              dataLinkId: ["sale", "women", "veilance"],
                              href: "/c/womens/bfs-veilance/wid-kjyr6zq9",
                              className: "sale-women-links",
                            })}
                        </div>
                    </ul>
                    <ul class="shop-more">
                        ${generateNavLink({
                          text: data.Mens,
                          dataLinkId: ["sale", "men", "men"],
                          href: "/c/mens/black-friday-sale/wid-kjyr6zq9",
                          className: "sectionhead sale-men-links",
                        })}
                        <div class="mobilefly">
                            ${generateNavLink({
                              text: data["Shell Jackets"],
                              dataLinkId: ["sale", "men", "shell-jackets"],
                              href: "/c/mens/bfs-shell-jackets/wid-kjyr6zq9",
                              className: "sale-men-links",
                            })}
                            ${generateNavLink({
                              text: data["Insulated Jackets"],
                              dataLinkId: ["sale", "men", "insulated-jackets"],
                              href: "/c/mens/bfs-insulated-jackets/wid-kjyr6zq9",
                              className: "sale-men-links",
                            })}
                            ${generateNavLink({
                              text: data.Bottoms,
                              dataLinkId: ["sale", "men", "bottoms"],
                              href: "/c/mens/bfs-bottoms/wid-kjyr6zq9",
                              className: "sale-men-links",
                            })}
                            ${generateNavLink({
                              text: data.Accessories,
                              dataLinkId: ["sale", "men", "accessories"],
                              href: "/c/mens/bfs-accessories/wid-kjyr6zq9",
                              className: "sale-men-links",
                            })}
                            ${generateNavLink({
                              text: data.Packs,
                              dataLinkId: ["sale", "men", "packs"],
                              href: "/c/mens/bfs-packs/wid-kjyr6zq9",
                              className: "sale-men-links",
                            })}
                            ${generateNavLink({
                              text: data["Base Layer"],
                              dataLinkId: ["sale", "men", "base-layer"],
                              href: "/c/mens/bfs-base-layers/wid-kjyr6zq9",
                              className: "sale-men-links",
                            })}
                            ${generateNavLink({
                              text: data.Footwear,
                              dataLinkId: ["sale", "men", "footwear"],
                              href: "/c/mens/bfs-footwear/wid-kjyr6zq9",
                              className: "sale-men-links",
                            })}
                            ${generateNavLink({
                              text: data.Fleece,
                              dataLinkId: ["sale", "men", "fleece"],
                              href: "/c/mens/bfs-fleece/wid-kjyr6zq9",
                              className: "sale-men-links",
                            })}
                            ${generateNavLink({
                              text: "Veilance",
                              dataLinkId: ["sale", "men", "veilance"],
                              href: "/c/mens/bfs-veilance/wid-kjyr6zq9",
                              className: "sale-men-links",
                            })}
                        </div>
                    </ul>
                </ul>
                <div class="feature">
                    <a class="content" data-linkid="gift-guide:bestsellers" href="/c/womens/black-friday-sale/wid-kjyr6zq9">
                        <h6>${data["Best Sellers"]}</h6>
                    </a>
                </div>
            </div>
        </div>
    </li>
`;

export const headerOutdoorMenus = ({ data, language, country }) =>
  `
<nav>
    <ul>
        ${womensListItem(data, country)}
        ${mensListItem(data, country)}        
        <li>
            <a class="head" id="footwear" href="/c/footwear" data-linkid="main-nav:footwear">${data.Footwear}</a>
            <div class="sub-menu">
                <div class="container" >
                    ${footwearShoppingCategoryMenu(data, country)}
                    <div class="feature" id="footwear-feature">
                        <a class="content" data-linkid="footwear:exclusives" href="/shop/footwear">
                            <h6>${data.Exclusives}</h6>
                        </a>
                    </div>
                </div>
            </div>
        </li>
        <li>
            <a class="head explore" id="explore" href="/explore"  data-linkid="">${data["$^explore^$"]}</a>
            <div class="sub-menu">
                <div class="container">
                    <ul class="explore">
                        <li class="sectionhead shop-more" tabindex="1">
                            <span>${data["$^explore^$"]}</span>
                        </li>
                        <div class="mobilefly">
                            <li class="winter-film-tour">
                                <a data-linkid="explore:winter-film-tour" href="https://events.arcteryx.com/film-tour/${language}">
                                    Winter Film Tour 2024
                                </a>
                            </li>
                            <li class="whoweare">
                                <a  data-linkid="explore:who-we-are" href="/explore/whoweare">${
                                  data["$^nav-whoweare^$"]
                                }</a>
                            </li>
                            <li class="blog">
                                <a data-linkid="explore:blog" href="//blog.arcteryx.com">
                                  Blog
                                </a>
                            </li>
                            <li class="films CA-only US-only" style='display:none'>
                                <a data-linkid="explore:films" href="/explore/films">Films</a>
                            </li>
                            <li class="community-events">
                            <a data-linkid="explore:community-events" href="http://community-events.arcteryx.com">${
                              data["$^community-events^$"]
                            }</a>                            </li>
                            <li class="academy">
                                <a data-linkid="explore:academy" href="//arcteryxacademy.com">Academies</a>
                            </li>
                            <li class="athletes">
                                <a data-linkid="explore:athletes" href="/athletes">${data["Athletes & Ambassadors"]}</a>
                            </li>
                            <li class="rebird JP-block CN-block AU-block NZ-block">
                                <a data-linkid="explore:rebird" href="/explore/rebird">ReBird™</a>
                            </li>
                            <li class="sustainability">
                                <a data-linkid="explore:sustainability" href="/explore/sustainability">${
                                  data["$^nav-sustainability^$"]
                                }</a>
                            </li>
                            <li class="arc-naming-scheme">
                            <a data-linkid="explore:arc-naming-scheme" href="/help/arc-naming">${
                              data["$^arc-naming-scheme^$"]
                            }</a>
                            </li>

                            <li class="obsessive-design">
                            <a data-linkid="explore:obsessive-design" href="/explore/obsessive-design">${
                              data["Obsessive Design"]
                            }</a>
                            </li>

                            <li class="micon-litric-avalanche-airbag">
                            <a data-linkid="explore:micon-litric-avalanche-airbag" href="/shop/micon-litric">${
                              data["Micon LiTRIC Avalanche Airbag"]
                            }</a>
                            </li>

                            <li class="epe-fabric-sustainability">
                            <a data-linkid="explore:epe-fabric-sustainability" href="/shop/epe-fabric">${
                              data["ePE & Fabric Sustainability"]
                            }</a>
                            </li>

                            ${displayProductAdvice(data, language)}

                            <li class="SS24_WalkGently AT-block BE-block CZ-block DK-block FI-block FR-block DE-block GB-block IE-block IT-block NO-block PL-block ES-block SE-block CH-block NL-block CA-block US-block">
                                <a data-linkid="explore:walk-gently" href="/explore/walk-gently">
                                    Walk Gently
                                </a>
                            </li>

                        </div>
                    </ul>
                    <div class="feature">
                        <a data-linkid="explore" class="content" href="/explore">
                            <h6>${data["$^explore^$"]}</h6>
                        </a>
                    </div>
                    <div class="contact">
                        <p>${data["$^SignUpTitle^$"]}</p>
                        <p class="JP-block">${data["$^SignUpBodyCopy2^$"]}</p>
                        <div>
                            <a data-linkid="explore" href="${EMAIL_SIGNUP}" tabindex="0" class="email__signup standard__cta-button" style="cursor: pointer">
                              ${data["$^SignUpCta2^$"]}
                            </a>
                        </div>
                        <p class="heading">${data["$^footer-followUs-header^$"]}</p>
                        <ul class="social">
                            <li>
                                <a data-linkid="explore:facebook" href="//facebook.com/arcteryx" class="social-na facebook" target="_blank" rel="noopener" title="Facebook">
                                    <span>Facebook</span>
                                </a>
                            </li>
                            <li>
                                <a data-linkid="explore:instagram" href="//instagram.com/arcteryx" class="social-na instagram" target="_blank" rel="noopener" title="Instagram">
                                    <span>Instagram</span>
                                </a>
                            </li>
                            <li>
                                <a data-linkid="explore:twitter" href="//twitter.com/arcteryx" class="social-na twitter" target="_blank" rel="noopener" title="Twitter">
                                    <span>Twitter</span>
                                </a>
                            </li>
                            <li>
                                <a data-linkid="explore:pinterest" href="//www.pinterest.com/arcteryx" class="social-na pinterest"
                                    target="_blank" rel="noopener" title="Pinterest">
                                    <span>Pinterest</span>
                                </a>
                            </li>
                            <li>
                                <a data-linkid="explore:youtube" href="//www.youtube.com/arcteryxequipmentinc" class="social-na youtube"
                                    target="_blank" rel="noopener" title="Youtube">
                                    <span>Youtube</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </li>
        ${giftGuide(data)}
        ${salesTab(data)}
        ${
          isGiftGuideEnabled() && !isBlackFridaySaleEnabled(country)
            ? `<li>
            <a class="head gift_guide" id="gift_guide" href="/shop/giftguide"  data-linkid="gift-guide">${
              data["$^gift-guide^$"]
            }</a>
            <div class="sub-menu">
                <div class="container gift_guide">
                    <div>
                        ${womensGiftGuideMenu(data, country)}
                        ${mensGiftGuideMenu(data, country)}
                    </div>
                    <div class="feature">
                        <a class="content" data-linkid="">
                            <h6 data-prefix="gift_guide">${data["$^gift-guide^$"]}</h6>
                        </a>
                    </div>
                </div>
            </div>
        </li>`
            : ""
        }
        ${
          isBlackFridaySaleEnabled(country)
            ? `<li>
            <a class="head explore ${
              ["fr", "de", "es"].includes(language) ? "hide_sale" : ""
            }" id="sale" data-linkid="sale">${data.Sale}</a>
            <div class="sub-menu">
                <div class="container sale">
                    <ul class="explore">
                        <div class="mobilefly">
                            <li class="f23_blackfridaysale">
                                <a  data-linkid="sale:black-friday-sale-mens" data-prefix="men" href="/c/mens/p/black-friday-sale">${
                                  data["Men's Black Friday Sale"]
                                }</a>
                            </li>
                            <li class="f23_blackfridaysale">
                                <a  data-linkid="sale:black-friday-sale-womens" data-prefix="women" href="/c/womens/p/black-friday-sale">${
                                  data["Women's Black Friday Sale"]
                                }</a>
                            </li>
                        </div>
                    </ul>
                    <div class="feature">
                        <a class="content" data-linkid="">
                            <h6 data-prefix="sale">${data["Black Friday Sale"]}</h6>
                        </a>
                    </div>
                </div>
            </div>
        </li>`
            : ""
        }
    </ul>
</nav>
`;
